import { api } from "./api";

export const intakeSummarizerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    intakeSummary: builder.query<string, string>({
      query: (visitId) => ({
        method: "POST",
        url: `/api/intake-summarizer/visit/${visitId}`,
        responseHandler: "text",
      }),
    }),
  }),
});

export const { useIntakeSummaryQuery } = intakeSummarizerApi;
